/** Strings of the app shell (`src/app`). Owner: Platform. */
export const app = {
  'app.name': 'Маргиналии',
  'app.tagline': 'Звери на полях рукописи',
  'app.screen.boot': 'Загрузка',
  'app.screen.title': 'Титул',
  'app.screen.settings': 'Настройки',
  'app.boot.loading': 'Писец растирает краски…',
  'app.boot.noscript': 'Для «Маргиналий» нужен включённый JavaScript.',
  // Boot scribe lines (ui-ux §6.1: 12 entries, rotate every 1.6 s)
  'app.boot.line.1': 'Растираем лазурит…',
  'app.boot.line.2': 'Точим перья…',
  'app.boot.line.3': 'Золотим нимбы…',
  'app.boot.line.4': 'Отгоняем мышей от пергамента…',
  'app.boot.line.5': 'Разводим киноварь…',
  'app.boot.line.6': 'Линуем поля…',
  'app.boot.line.7': 'Будим брата-писца…',
  'app.boot.line.8': 'Сушим чернила над свечой…',
  'app.boot.line.9': 'Пересчитываем котов на полях…',
  'app.boot.line.10': 'Сдуваем пыль с переплёта…',
  'app.boot.line.11': 'Ищем запропастившуюся кисть…',
  'app.boot.line.12': 'Уговариваем гуся отдать перо…',
  'app.boot.slow': 'Всё ещё переписываем — старый монастырь, медленные монахи',
  'app.boot.progress': '{p} %',
  // Lite mode «Без миниатюр» banner and sheet (ui-ux §6.2 E1–E4, §6.26)
  'app.lite.name': 'Упрощённая графика',
  'app.lite.banner.noApi': 'Все приключения доступны и без WebGPU.',
  'app.lite.banner.insecure': 'Для объёмных боевых сцен нужен HTTPS. Можно играть дальше.',
  'app.lite.banner.noAdapter': 'Объёмные сцены отдыхают. Все приключения доступны.',
  'app.lite.banner.lost': 'Краски пролились. Продолжаем с рисованными боевыми сценами.',
  'app.lite.more': 'Подробнее ›',
  'app.lite.close': 'Скрыть',
  'app.lite.sheet.body': 'WebGPU рисует объёмные боевые сцены. Без него бои показаны рисованными фигурками. Конструктор, приключения, карты, гонки и сохранения работают как обычно.',
  'app.lite.sheet.where': 'Чтобы включить объёмные боевые сцены:',
  'app.lite.sheet.b1': 'свежий Chrome или Edge',
  'app.lite.sheet.b2': 'Safari 26 и новее',
  'app.lite.sheet.b3': 'Firefox на Windows',
  'app.lite.sheet.b4': 'включить аппаратное ускорение',
  'app.lite.code': 'Код: {code}',
  'app.lite.retry': 'Попробовать снова',
  'app.lite.retry.busy': 'Пробуем…',
  'app.lite.retry.fail': 'Не вышло: краски всё ещё не держатся.',
  'app.lite.retry.ok': 'Получилось! Миниатюры оживут на следующей странице.',
  'app.lite.ok': 'Понятно',
  // Device lost (ui-ux §6.2 E6; architecture §11)
  'app.gpu.lost': 'Чернила пролились — перерисовываем…',
  'app.gpu.lost.failed': 'Миниатюры не просохли.',
  'app.gpu.restart': 'Перезапустить',
  'app.gpu.lite': 'Упрощённая графика',
  // Save (architecture §4.2)
  'app.save.readonly.title': 'Список новее писца',
  'app.save.readonly.body': 'Этот список сделан более новой рукописью. Чтобы его не испортить, писец ничего не записывает. Обновите страницу.',
  'app.save.copied': 'Копия списка в буфере обмена. Сохраните её подальше от мышей.',
  'app.save.import.title': 'Загрузить копию', 'app.save.import.code': 'Код сохранения',
  'app.save.import.hint': 'Вставь код из сохранённой копии. Писец проверит его перед загрузкой.',
  'app.save.import.check': 'Проверить копию', 'app.save.import.invalid': 'Копия повреждена или требует другую редакцию игры. Текущий прогресс не изменён.',
  'app.save.import.confirm': 'Заменить текущую летопись?',
  'app.save.import.replace': 'Копия заменит героя и все его подвиги на этом устройстве. Сначала сохрани текущую летопись, если хочешь к ней вернуться.',
  'app.save.import.done': 'Летопись загружена.',
  'app.diag.copied': 'Диагностика скопирована.',
  'app.clipboard.failed': 'Буфер обмена не дался писцу.',
  'app.save.full': 'Место в книге кончилось: список не сохранён.',
  'app.save.restored': 'Последний лист испорчен — писец восстановил список с прежней копии.',
  // Second tab (ui-ux §3.4)
  'app.lock.title': 'Открыто в другой вкладке',
  'app.lock.body': 'Летопись уже ведётся в другой вкладке. Два писца на одном листе — к кляксам.',
  'app.lock.take': 'Играть здесь',
  // Fatal E0 (ui-ux §6.2)
  'app.fatal.title': 'Летопись не открылась',
  'app.fatal.body': 'Что-то помешало книге раскрыться. Обновите страницу, а если не поможет — скопируйте диагностику для писца.',
  'app.fatal.reload': 'Обновить',
  'app.fatal.copy': 'Скопировать диагностику',
  'app.fatal.copied': 'Скопировано',
  // A screen whose create() threw
  'app.error.screen.title': 'Глава не открылась',
  'app.error.screen.body': 'Писец споткнулся на этой странице. Вернитесь назад — остальная книга цела.',
  'app.nav.back': 'Назад',
  // Title (ui-ux §6.3)
  'app.title.subtitle': 'звери с полей старой книги',
  'app.title.start': 'Начать летопись',
  'app.title.continue': 'Продолжить летопись',
  'app.title.poke': 'Потрогать зверя',
} as const;
